<template>
  <div>
    <service></service>
  </div>
</template>
<script>
import service from '@/components/serviceInfo'

export default {
  components: {
    service
  },
  data () {
    return {

    }
  },
  created () {
    console.log(this.$route.query)
  }
}
</script>
<style lang="scss" scoped>
</style>
